// live production url

// const api = "http://api.agrotraemarketplace.com/api/v1/";
// const agroUserUrl = "https://agrotraemarketplace.com/";
// const companyUrl = "https://agrotraemarketplace.com/company";

// test localhost url
const api = 'http://localhost:80/api/v1/'
const agroUserUrl = 'http://localhost:80/api/v1/'
const companyUrl = 'http://localhost:80/company'
const adminUrl = 'http://localhost:80/admin'

export default {
  api,
  agroUserUrl,
  companyUrl,
  adminUrl,
}
